var LIB_ID_KEY = "viewAsLibraryId";
var LIB_NAME_KEY = "viewAsLibraryName";
var listeners = new Set();
var notify = function () { return listeners.forEach(function (listener) { return listener(); }); };
export var subscribeViewAsLibrary = function (listener) {
    listeners.add(listener);
    return function () {
        listeners.delete(listener);
    };
};
export var getViewAsLibraryId = function () {
    return sessionStorage.getItem(LIB_ID_KEY);
};
export var getViewAsLibraryName = function () {
    return sessionStorage.getItem(LIB_NAME_KEY);
};
export var setViewAsLibrary = function (id, name) {
    sessionStorage.setItem(LIB_ID_KEY, id);
    sessionStorage.setItem(LIB_NAME_KEY, name);
    notify();
};
export var clearViewAsLibrary = function () {
    sessionStorage.removeItem(LIB_ID_KEY);
    sessionStorage.removeItem(LIB_NAME_KEY);
    notify();
};
